import PropertyFormGeneric from "@rf/property/module/components/property-form/PropertyFormGeneric";
import {
  CPropertyForm,
  CPropertyFormKeys,
  IPropertyForm
} from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import { useCreatePropertyMutation } from "@/src-refactor/modules/store/qrtk/services/realestate/realestate.qrtk";
import toast from "react-hot-toast";
import { UseFormReturn } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { C_PATH_ROUTES } from "@/src-refactor/modules/shared/model/const/path.const";
import {
  HCatchServerError,
  HToastCatchServerError
} from "@rf-helper/cath-error-server";
import { useResetAllFormStates } from "@rf/property/module/components/property-form/store/propertyStore";
import { useCallback, useEffect, useMemo } from "react";
import dispatchMessagesOverlay from "@rf-l1/loading/mx-overlay-loading/util/dispatchMessagesOverlay";
import { Grid } from "@mui/material";
import TypographyOverlay from "@rf-l1/loading/mx-overlay-loading/components/TypographyOverlay";
import simulatorRequest from "@rf-helper/simulator-request";
import useGetTypePropertyFromUrl from "../../components/property-form/hooks/useCheckTypeProperty";
import { createProjectPayloadAdapter } from "../../adapters/form/create-project-property-adapter";
import { PROPERTIES_MAIN_OVERLAY_ID } from "../../components/property-form/util/const/properties-overlays.const";
import { C_BUSINESS_TYPE } from "@/src-refactor/modules/shared/model/const/property/business-type.const";
import { CPropertyBuildingForm } from "../../components/property-form/util/schemas/building-form/building.schema";
import { CPropertyBuildingUnitForm } from "../../components/property-form/util/schemas/building-form/building-unit.schema";

const PropertyProjectCreationPage = () => {
  const [CREATE_PROPERTY_M] = useCreatePropertyMutation();
  const resetAllFormStates = useResetAllFormStates();
  const { getTypeProperty } = useGetTypePropertyFromUrl();

  const router = useNavigate();

  useEffect(() => {
    return () => {
      resetAllFormStates();
    };
  }, []);

  const createProject = useCallback(async (v: IPropertyForm) => {
    const body = createProjectPayloadAdapter(v);

    return CREATE_PROPERTY_M({ body })
      .unwrap()

      .catch(e => {
        console.log(e);
        toast.error(HCatchServerError(e));
      });
  }, []);

  const handleSubmit = useCallback(
    async (v: IPropertyForm, helper: UseFormReturn<IPropertyForm>) => {
      try {
        dispatchMessagesOverlay("Guardando proyecto", PROPERTIES_MAIN_OVERLAY_ID);

        await simulatorRequest({
          onEndSimulated: "resolve"
        });

        dispatchMessagesOverlay(
          <Grid container spacing={0.5}>
            <Grid item xs={12}>
              <TypographyOverlay text="Estamos dando forma a tu proyecto…" />
            </Grid>
            <Grid item xs={12}>
              <TypographyOverlay text="Recuerda estar atento a la revisión y aprobación de tu proyecto." />
            </Grid>
          </Grid>,
          PROPERTIES_MAIN_OVERLAY_ID
        );

        const res = (await createProject(v).catch(e =>
          HToastCatchServerError(e)
        )) as any;

        dispatchMessagesOverlay(
          "¡Casi listo! Tu proyecto estará disponible en breve.",
          PROPERTIES_MAIN_OVERLAY_ID
        );

        if (res?.data?.id) {
          helper.reset(CPropertyForm as unknown as IPropertyForm);

          router(
            `${C_PATH_ROUTES.REALESTATE.DETAIL(
              res.data.id
            )}?isNewProperty=true&isProject=true`,
            {
              replace: true
            }
          );
        } else {
          toast.error("Error al crear el Borrador");
        }
      } catch (e: any) {
        console.error(e);
      }
    },
    []
  );

  const stateForm = useMemo(() => {
    const createDefaultUnit = () => ({
      ...CPropertyBuildingUnitForm,
      id: crypto.randomUUID(),
      uuid: crypto.randomUUID(),
      isNew: true
    });

    const createDefaultBuilding = () => ({
      ...CPropertyBuildingForm,
      id: crypto.randomUUID(),
      uuid: crypto.randomUUID(),
      isNew: true,
      isCaptured: true,
      units: [createDefaultUnit()]
    });

    return {
      ...CPropertyForm,
      [CPropertyFormKeys.is_project]: true,
      [CPropertyFormKeys.is_edit]: false,
      [CPropertyFormKeys.type_property]: getTypeProperty(),
      [CPropertyFormKeys.business_types_property]: [C_BUSINESS_TYPE.SALE],
      [CPropertyFormKeys.building]: [createDefaultBuilding()]
    } as unknown as IPropertyForm;
  }, []);

  return <PropertyFormGeneric state={stateForm} onSubmit={handleSubmit} />;
};

export default PropertyProjectCreationPage;
